import React, { useState } from "react";
import ModalComponent from "../../../../features/ModalComponent";
import { AssortGroup } from "../../../models/AssortGroup";
import CalendarPass from "../CalendarPass";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "../../../../style/buttons.scss";
import "../../../../style/hovers.scss";
import { BsCalendarRange } from "react-icons/bs";
import usePasses from "../hooks/usePasses";
import { MdAddShoppingCart, MdOutlineAddShoppingCart } from "react-icons/md";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../store";
import { useMediaQuery } from "@mui/material";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";

interface IProps {
  item: AssortGroup;
  handleOpenPassModal: () => void;
  index: number;
  handlePassIndex: (value: number) => void;
}

const SinglePass: React.FC<IProps> = ({ item, handleOpenPassModal, handlePassIndex, index }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { selectedDate, setDateBetween } = usePasses();
  const { handleAddBasketLimited } = useBasketManager();
  const { scrollToTop } = useParentMessage();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const mobile = useMediaQuery("(min-width: 980px)");
  return (
    <div className="singlePass">
      <div className="img" style={{ backgroundImage: `url(${item.picture})` }}></div>

      <div className="content">
        <div className="text">
          <h3>{item.name}</h3>
          <article className="text-description" dangerouslySetInnerHTML={{ __html: item.description }}></article>
        </div>

        <div className="line"></div>

        <div className="buttons flex-between-center">
          <div className="flex-column flex-wrap">
            <b>
              {item.price} {t("zl")}
            </b>
            <span>
              {t("waznosc")} {item.dayValidate + 1} {t("dni")}
            </span>
          </div>
          {saleConfiguration.passSale_ChooseDateAtSale ? (
            <React.Fragment>
              {mobile ? (
                <button
                  className="button medium padding-small button-fill-main"
                  onClick={() => {
                    setOpen(true);
                    scrollToTop();
                  }}
                >
                  {t("wybierz")}
                  <BsCalendarRange className="icon" />
                </button>
              ) : (
                <button
                  className="button medium padding-small button-fill-main"
                  onClick={() => {
                    handleOpenPassModal();
                    handlePassIndex(index);
                    scrollToTop();
                  }}
                >
                  {t("wybierz")}
                  <BsCalendarRange className="icon" />
                </button>
              )}
            </React.Fragment>
          ) : (
            <button
              onClick={() => {
                handleAddBasketLimited(item, 1);
              }}
              className="button medium padding-medium button-fill-main"
            >
              {t("dodaj")}
              <MdOutlineAddShoppingCart className="icon" />
            </button>
          )}
        </div>
      </div>

      {open && (
        <ModalComponent
          leftType="pass"
          leftTitle={`${item.name}`}
          leftImage={`${item.picture}`}
          leftText={`${item.description}`}
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("wybierz_date_rozpoczecia")}
          onAccept={() => {}}
        >
          <div>
            <CalendarPass selectedDate={selectedDate} setDateBetween={setDateBetween} item={item} />
            <button
              onClick={() => {
                handleAddBasketLimited(item, 1, selectedDate);
                setOpen(false);
              }}
              className="full-button button medium padding-medium button-fill-main move-up"
            >
              {t("dodaj_do_koszyka")}
              <MdAddShoppingCart className="icon" />
            </button>
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

export default SinglePass;
